import {SectionNavCardViewProps} from './SectionNavCard.interfaces';
import SectionNavCardView from './SectionNavCard.view';

export function SectionNavCardContainer(props: SectionNavCardViewProps) {
  return <SectionNavCardView {...props} />;
}
